import { render, staticRenderFns } from "./Ribbon.vue?vue&type=template&id=a91f10c8"
import script from "./Ribbon.vue?vue&type=script&lang=js"
export * from "./Ribbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports